import { INotificationState } from "./types";

export const initialState: INotificationState = {
  notificationList: {
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
  },
  notification: {
    notificationloading: false,
    notificationloaded: false,
    data: [],
  },
  ssoId: 0,
};
